import React from 'react';
import { motion } from 'framer-motion';

interface PaginationInfo {
  totalPages: number;
  page: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
}

interface PaginationProps {
  paginationInfo: PaginationInfo;
  fetchCourses: (page: number, filters: any) => void;
  appliedFilters: Record<string, any>;
}

const Pagination: React.FC<PaginationProps> = ({
  paginationInfo,
  fetchCourses,
  appliedFilters,
}) => {
  return (
    <motion.div
      className="flex justify-center items-center gap-2 mt-8"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {paginationInfo.hasPrevPage && (
        <button
          onClick={() => fetchCourses(paginationInfo.page - 1, appliedFilters)}
          className="px-3 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
        >
          ← Trước
        </button>
      )}

      <span className="text-sm text-gray-600 dark:text-gray-400">
        Trang {paginationInfo.page} / {paginationInfo.totalPages}
      </span>

      {paginationInfo.hasNextPage && (
        <button
          onClick={() => fetchCourses(paginationInfo.page + 1, appliedFilters)}
          className="px-3 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
        >
          Sau →
        </button>
      )}
    </motion.div>
  );
};

export default Pagination;
